import React from 'react';

interface HeadingWrapperProps {
    children: React.ReactNode;
}
function HeadingWrapper({ children }: HeadingWrapperProps) {
    return <div>{children}</div>;
}

export default HeadingWrapper;
